import { MessageType } from 'api/MessageTypeAPI';
import {
  CHANNEL_CONFIGURATION_ACTION,
  useChannelModalsContext,
  useChannelsContext,
} from 'modules/channels/contexts';
import { CreateChannelModal } from './CreateChannelModal';
import { DeleteChannelModal } from './DeleteChannelModal';
import { DeleteMessageTypeModal } from './DeleteMessageTypeModal';
import { IgnoreFrequencyCapModal } from './IgnoreFrequencyCapModal';
import { ManageMessageTypeModal } from './ManageMessageTypeModal';
import { UpdateChannelModal } from './UpdateChannelModal';
import { UpdateFrequencyCapModal } from './UpdateFrequencyCapModal';
import { UpdateRateLimitModal } from './UpdateRateLimitModal';
import { UpdateToDoubleOptInModal } from './UpdateToDoubleOptInModal';

export const ChannelModals = () => {
  const { modalState, hideModal } = useChannelModalsContext();

  const { messageMedium, refetchChannels, refetchMessageTypes } = useChannelsContext();

  if (modalState === null) return null;

  const { action, channel, messageType } = modalState;

  switch (action) {
    case CHANNEL_CONFIGURATION_ACTION.CREATE_MESSAGE_TYPE:
      return (
        <ManageMessageTypeModal
          onClose={hideModal}
          channel={channel}
          messageType={messageType}
          isEditMode={false}
        />
      );

    case CHANNEL_CONFIGURATION_ACTION.EDIT_MESSAGE_TYPE:
      return (
        <ManageMessageTypeModal
          onClose={hideModal}
          channel={channel}
          messageType={messageType}
          isEditMode={true}
        />
      );

    case CHANNEL_CONFIGURATION_ACTION.UPDATE_RATE_LIMIT:
      return <UpdateRateLimitModal onClose={hideModal} messageType={messageType as MessageType} />;

    case CHANNEL_CONFIGURATION_ACTION.UPDATE_FREQUENCY_CAP:
      return (
        <UpdateFrequencyCapModal onClose={hideModal} messageType={messageType as MessageType} />
      );

    case CHANNEL_CONFIGURATION_ACTION.IGNORE_FREQUENCY_CAP:
      return (
        <IgnoreFrequencyCapModal onClose={hideModal} messageType={messageType as MessageType} />
      );

    case CHANNEL_CONFIGURATION_ACTION.CREATE_CHANNEL:
      return (
        <CreateChannelModal
          messageMedium={messageMedium}
          onClose={hideModal}
          refetchChannels={refetchChannels}
        />
      );

    case CHANNEL_CONFIGURATION_ACTION.EDIT_CHANNEL:
      return <>{channel && <UpdateChannelModal channel={channel} onClose={hideModal} />}</>;

    case CHANNEL_CONFIGURATION_ACTION.DELETE_CHANNEL:
      return (
        <>
          {channel && (
            <DeleteChannelModal
              channel={channel}
              onClose={hideModal}
              refetchChannels={refetchChannels}
            />
          )}
        </>
      );

    case CHANNEL_CONFIGURATION_ACTION.DELETE_MESSAGE_TYPE:
      return (
        <DeleteMessageTypeModal
          onClose={hideModal}
          messageType={messageType as MessageType}
          refetchMessageTypes={refetchMessageTypes}
        />
      );

    case CHANNEL_CONFIGURATION_ACTION.UPDATE_TO_DOUBLE_OPT_IN:
      return (
        <UpdateToDoubleOptInModal
          onClose={hideModal}
          messageType={messageType as MessageType}
          refetchMessageTypes={refetchMessageTypes}
        />
      );

    default:
      return null;
  }
};
